<template>
  <b-overlay :show="formShow" rounded="sm" no-fade class="mt-1">
    <b-card>
      <b-row class="mb-1">
        <b-col
          cols="12"
          md="7"
          class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <b-button
            variant="outline-primary"
            class="btn-icon"
            @click="$router.go(-1)"
          >
            <i class="fa-solid fa-arrow-left"></i>
            <span class="ml-25">Back</span>
          </b-button>
        </b-col>
      </b-row>
      <b-row class="mb-1">
        <table class="table table-sm">
          <thead>
            <tr>
              <th scope="col">
                {{ ownerId ? "Owner Edit" : "Owner Add" }}
              </th>
            </tr>
          </thead>
        </table>
      </b-row>

      <validation-observer ref="ownerRules">
        <b-form>
          <b-row>
            <b-col cols="6" md="12" sm="12">
              <b-form-group label="Owner Title" label-for="title">
                <validation-provider
                  name="title"
                  #default="{ errors }"
                  rules="required"
                >
                  <textarea
                    v-model="ownerValue.title"
                    class="form-control"
                    id="title"
                    name="title"
                    rows="3"
                  ></textarea>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>

          <hr />

          <b-row>
            <b-col cols="12">
              <b-button
                type="submit"
                @click.prevent="formSubmitted"
                variant="primary"
                class="float-right"
              >
                {{ ownerId ? "Update Owner" : "Create Owner" }}
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-card>
  </b-overlay>
</template>

<script>
import store from "@/store";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { onUnmounted } from "@vue/composition-api";
import settingsStoreModule from "../settingsStoreModule";
import vSelect from "vue-select";
import router from "@/router";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required, email } from "@validations";

export default {
  components: {
    vSelect,
    ToastificationContent,
    ValidationProvider,
    ValidationObserver,
  },

  setup() {
    const OWNER_CODE_APP_STORE_MODULE_NAME = "settings";

    if (!store.hasModule(OWNER_CODE_APP_STORE_MODULE_NAME)) {
      store.registerModule(
        OWNER_CODE_APP_STORE_MODULE_NAME,
        settingsStoreModule
      );
    }

    onUnmounted(() => {
      if (store.hasModule(OWNER_CODE_APP_STORE_MODULE_NAME)) {
        store.unregisterModule(OWNER_CODE_APP_STORE_MODULE_NAME);
      }
    });
  },

  data() {
    return {
      ownerValue: {
        title: "",
      },
      formShow: false,
      ownerId: null,
    };
  },

  mounted() {
    this.initializeForm();
  },

  methods: {
    async initializeForm() {
      try {
        if (router.currentRoute.params.id) {
          this.formShow = true;
          this.ownerId = parseInt(router.currentRoute.params.id);
          await this.getOwnerById();
        }
      } catch (error) {
        this.formShow = false;
        this.handleError("Failed to initialize form.");
      }
    },

    getOwnerById() {
      return store
        .dispatch("settings/getOwnerById", { id: this.ownerId })
        .then((res) => {
          this.ownerValue = res.data;
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          this.formShow = false;
        });
    },

    formSubmitted() {
      this.formShow = true;

      this.$refs.ownerRules.validate().then((success) => {
        if (success) {
          const owner = this.ownerId
            ? "settings/updateOwner"
            : "settings/saveOwner";

          store
            .dispatch(owner, this.ownerValue)
            .then(() => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Successfully",
                  text: this.ownerId
                    ? "✔️ Owner Update Successful"
                    : "✔️ Owner Added Successfully",
                  icon: "ThumbsUpIcon",
                  variant: "success",
                },
              });

              router.push({ name: "settings-owners" });
            })
            .catch((e) => {
              console.log(e);
              const errorMessage =
                e.response?.data?.errors?.title?.[0] ||
                "An error occurred while saving the owner.";
              this.handleError(errorMessage);
            })
            .finally(() => {
              this.formShow = false;
            });
        } else {
          this.formShow = false;
        }
      });
    },

    handleError(message) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: "Error",
          text: message,
          icon: "AlertCircleIcon",
          variant: "danger",
        },
      });
      this.formShow = false;
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
